import { computed } from 'vue';
import { useMainStore } from '../store/index';

const useServiceSavingsTexts = () => {
  const store = useMainStore();

  const serviceSavingsTexts = computed(() => {
    const returnObject = {};
    store.serviceSavings.forEach(({ key, subheaderKey, text, information }) => {
      returnObject[key] = { ...returnObject[key], [subheaderKey]: { text, information } };
    });
    return returnObject;
  });

  return {
    serviceSavingsTexts,
  };
};

export {
  useServiceSavingsTexts,
};
